<template>
  <div class="readonly-formcolor">
    <div class="breadcrumbs mb-2">
      <v-breadcrumbs divider=">" :items="breadcrumbsList">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="{ name: item.path }"
            :disabled="item.disabled"
            exact
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <PageTitle :pageHeading="pageHeading" :rightsideButton="false"> </PageTitle>

    <v-row class="tabs-row mb-5" no-gutters>
      <v-col
        v-show="$route.params.id"
        cols="12"
        md="12"
        class="pb-0 border-bottom"
      >
        <v-tabs
          color="#03b6fc"
          :mobile-breakpoint="960"
          show-arrows
          v-model="tab"
        >
          <v-tab class="body-2" href="#profile">Profile</v-tab>
          <v-tab class="body-2" href="#tickets"> Tickets </v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="12" md="12" class="pb-0">
        <v-tabs-items v-model="tab" light class="transparent">
          <v-tab-item value="profile">
            <v-container class="create-ticket customize-select">
              <v-form v-model="contactFormValid">
                <v-card>
                  <v-card-title>
                    Contact Details
                  </v-card-title>
                  <v-row class="ma-2">
                    <v-col
                      cols="12"
                      class="py-0"
                    >
                      <v-text-field
                        v-model="emailAddress"
                        outlined
                        :disabled="readOnly"
                        class="required email-address"
                        label="Email Address"
                        :rules="rules.email"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        :disabled="readOnly"
                        v-model="phoneNumber"
                        outlined
                        label="Phone Number"
                        @keypress="validPhoneNumber"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
                <v-card class="my-5">
                  <v-card-title>
                    Personal Details
                  </v-card-title>
                  <v-row class="ma-2">
                    <v-col>
                      <v-text-field
                        v-model="firstName"
                        outlined
                        label="First Name"
                        :disabled="readOnly"
                        hide-details
                        @keydown="validateNameInput"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="lastName"
                        outlined
                        label="Last Name"
                        :disabled="readOnly"
                        hide-details
                        @keydown="validateNameInput"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                    <v-text-field
                      v-model="company"
                      outlined
                      label="Company"
                      :disabled="readOnly"
                    >
                    </v-text-field>
                  </v-col>
                  </v-row>
                </v-card>
                <v-card>
                  <v-card-title>
                    Address
                  </v-card-title>
                  <v-row class="ma-2">
                    <v-col cols="12">
                      <v-text-field
                        v-model="streetAddress"
                        outlined
                        :disabled="readOnly"
                        class=""
                        label="Street Address"
                        hide-details
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="city"
                        outlined
                        class=""
                        label="City / Suburb"
                        :disabled="readOnly"
                        hide-details
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="6">
                    <v-autocomplete
                      v-model="country"
                      :items="countryList"
                      item-text="label"
                      item-value="value"
                      outlined
                      :disabled="readOnly"
                      class=""
                      label="Country"
                      clearable
                      attach
                      @change="changeCountry()"
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="state"
                      outlined
                      class=""
                      label="State"
                      :items="stateList"
                      item-text="label"
                      item-value="value"
                      attach
                      :disabled="readOnly"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="pincode"
                      outlined
                      class=""
                      label="Postcode"
                      :disabled="readOnly"
                    >
                    </v-text-field>
                  </v-col>
                  </v-row>
                </v-card>
                <v-divider class="my-5"></v-divider>
                <v-row class="mt-5">
                  <v-col cols="auto">
                    <v-btn
                      v-if="readOnly"
                      outlined
                      @click="redirectBack()"
                      class="font-weight-bold"
                      v-track="'redirect-to-contact-list'"
                    >
                      Back
                    </v-btn>
                    <v-btn
                      v-else
                      @click="redirectBack()"
                      outlined
                      id="cancel-action"
                      class="font-weight-bold"
                      v-track="'redirect-to-contact-list'"
                    >
                      Cancel
                    </v-btn>
                  </v-col>
                  <v-col cols="auto" v-if="readOnly">
                    <v-btn
                      v-if="restore"
                      dark
                      @click="restoreContact()"
                      class="font-weight-bold"
                      v-track="'restore-archieve-contact'"
                    >
                      Restore
                    </v-btn>
                    <v-btn
                      v-else
                      dark
                      class="font-weight-bold"
                      @click="enableEdit()"
                      v-track="'enable-edit-contact-form'"
                    >
                      edit
                    </v-btn>
                  </v-col>
                  <v-col cols="auto" v-else>
                    <v-btn
                      v-if="editAction"
                      :dark="contactFormValid"
                      :disabled="!contactFormValid"
                      @click="editContact()"
                      class="font-weight-bold"
                      v-track="'save-updated-contact'"
                    >
                      Save
                    </v-btn>

                    <v-btn
                      v-else
                      id="create-new-ticket"
                      class="mr-4 ml-2 font-weight-bold white--text"
                      v-track="'save-new-contact'"
                      @click="createNewContact"
                      :disabled="!contactFormValid"
                      :dark="contactFormValid"
                    >
                      Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-tab-item>
          <v-tab-item value="tickets" v-if="$route.params.id">
            <LinkedTickets :contactId="$route.params.id"></LinkedTickets>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import PageTitle from "@/components/shared/PageTitle";
import LinkedTickets from "@/components/contacts/AssociatedTickets.vue";
import { $contacts } from "@/services/Index";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "NewContact",
  components: {
    PageTitle,
    LinkedTickets,
  },
  data: () => ({
    breadcrumbsList: [
      {
        text: "Contacts",
        disabled: false,
        path: "contact-list",
      },
      {
        text: "New Contact",
        disabled: true,
        path: "",
      },
    ],
    pageHeading: "New Contact",
    contactFormValid: false,
    firstName: "",
    lastName: "",
    company: null,
    emailAddress: null,
    phoneNumber: null,
    streetAddress: null,
    city: null,
    state: null,
    country: null,
    pincode: null,
    tab: null,
    selectedContact: null,
    selectorClass: "",
    cancelDialog: false,
    loading: false,
    editAction: false,
    readOnly: false,
    restore: false,
    rules: {
      email: [
        v => !!v || 'Email is required',
        v => !v || !!v.trim() || 'Email cannot be blank',
        v => !v || /^[a-zA-Z0-9%+=._-]+@(([a-zA-Z0-9]|-)+\.)+([a-zA-Z])+$/.test(v) || 'Invalid email.',
      ],
    },
  }),

  computed: {
    ...mapGetters({
      countryList: 'app/countries',
      stateList: 'app/states'
    }),
  },

  mounted() {
    /** executing countries method from store  */
    this.$store.dispatch("app/getData");

    if (this.$route.params.id) {
      this.getSingleContact(this.$route.params.id);
      this.readOnly = true;
    }
    if (this.$route.path.indexOf("edit") > 1) {
      this.editAction = true;
      this.readOnly = false;
    }
  },
  methods: {
    ...mapActions({
      getStates: "app/getStates",
    }),

    changeCountry() {
      this.getStates(this.country);
      this.state = "";
    },

    redirectBack() {
      this.$router.push({ name: "contact-list" });
    },

    enableEdit() {
      this.readOnly = false;
      this.editAction = true;
    },

    /** Method to generate payload */
    contactPayload() {
      let payload = {
        contact: {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.emailAddress,
          phone: this.phoneNumber,
          company: this.company,
          address: this.streetAddress,
          country: this.country,
          state: this.state,
          city: this.city,
          postcode: this.pincode,
        },
      };
      return payload;
    },
    /** On click of save button createNewContact() function */
    async createNewContact() {
      let payload = this.contactPayload();
      let config = {};
      if (this.contactFormValid) {
        this.loading = true;
        try {
          const response = await $contacts.create(payload, config);
          if (response.data) {
            if (this.$route.query.ticket) {
              sessionStorage.setItem(
                "new-contact",
                JSON.stringify(response.data)
              );
              this.$router.push({
                name: "new-ticket",
                query: { addcontact: true },
              });
            } else {
              if (sessionStorage.getItem("new-contact") !== null) {
                sessionStorage.removeItem("new-contact");
              }
              this.$router.push({ name: "contact-list" });
            }

            this.$store.dispatch("ui/snackbar", [
              {
                title: "New contact",
                message: `New contact has been created`,
                type: "success",
              },
            ]);
            this.loading = false;
          }
        } catch (error) {
          this.loading = false;
          if (error.response !== undefined) {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Error",
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
          }
        }
      }
    },

    /** update contact update API request. */
    async editContact() {
      let payload = this.contactPayload();
      let config = {};
      if (this.contactFormValid) {
        this.loading = true;
        try {
          const response = await $contacts.update(
            this.$route.params.id,
            payload,
            config
          );
          if (response.data) {
            this.$router.push({ name: "contact-list" });
            this.$store.dispatch("ui/snackbar", [
              {
                title: "",
                message: `Contact details updated`,
                type: "success",
              },
            ]);
            this.loading = false;
          }
        } catch (error) {
          this.loading = false;
          if (error.response !== undefined) {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Error",
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
          }
        }
      }
    },

    /* eslint-disable */
    async restoreContact() {
      let payload = {
        deleted_at: null,
      };
      let config = {};
      try {
        const response = await $contacts.restore(
          this.$route.params.id,
          payload,
          config
        );
        if (response.data) {
          this.$store.dispatch("ui/snackbar", [
            {
              title: "",
              message: `Contact Successfully Restored`,
              type: "success",
            },
          ]);
          this.restore = false;
          this.loading = false;
        }
      } catch (error) {}
    },

    /* eslint-disable */
    /** get single contact data from API's */
    async getSingleContact(contactId) {
      this.loading = true;
      try {
        const response = await $contacts.fetchSingle(contactId, {});
        if (response.data) {
          this.updateFields(response.data);
          this.loading = false;
        }
      } catch (error) {}
    },

    updateFields(data) {
      this.firstName = data.first_name;
      this.lastName = data.last_name;
      this.pageHeading = this.firstName + " " + this.lastName;
      this.breadcrumbsList[1].text = this.pageHeading;
      this.company = data.company;
      this.emailAddress = data.email;
      this.phoneNumber = data.phone;
      this.streetAddress = data.address;
      if (data.country) {
        this.country = data.country;
        this.changeCountry();
      }
      this.state = data.state;
      this.city = data.city;
      this.pincode = data.postcode;
      if (data.deleted_at) {
        this.restore = true;
      }
    },
    /**
     * allow only numeric value
     */
     validPhoneNumber(event){
      var code = event.which || event.keycode;
      if (!(code >= 48 && code <= 57) && code!=46 && code!=43){
        event.preventDefault();
      }
      if(this.phoneNumber && this.phoneNumber.length >= 15){
        event.preventDefault();
      }
    },
    validateNameInput(event) {
      const isLetterOrSpace = /^[A-Za-z\s]$/.test(event.key);
      const isShiftKey = event.key === "Shift";
      const isShiftNumber = event.shiftKey && /^[0-9]$/.test(event.key);
      // Allow specific key presses for deletion, navigation, Caps Lock, Tab, and Shift + letter (uppercase)
      if (
        event.key === "Backspace" || 
        event.key === "Delete" || 
        event.key === "ArrowLeft" || 
        event.key === "ArrowRight" || 
        event.key === "CapsLock" || 
        event.key === "Tab" || 
        isLetterOrSpace || 
        (isShiftKey && !isShiftNumber) // Allow Shift key but restrict Shift + number key
      ) {
        return; // Allow the key press
      } else {
        event.preventDefault(); // Prevent all other characters
      }
    },
  },
};
</script>

<style lang="scss">
.email-address input {
  text-transform: inherit !important;
}
</style>
